import { create } from "zustand";
import { persist } from "zustand/middleware";

interface RecentsState {
  /** most-recent-first item ids */
  ids: string[];
  touch: (id: string) => void;
  remove: (ids: string[]) => void;
}

export const useRecents = create<RecentsState>()(
  persist(
    (set) => ({
      ids: [],
      touch: (id) =>
        set((s) => ({
          ids: [id, ...s.ids.filter((x) => x !== id)].slice(0, 50),
        })),
      remove: (ids) =>
        set((s) => ({ ids: s.ids.filter((x) => !ids.includes(x)) })),
    }),
    { name: "hn.recents" },
  ),
);
